import { IconChevronDown, IconSports } from "app/components/Icon/Icon";
import { FormattedMessage } from "react-intl";

export const MultipleCollapsibleHeader: React.FC<{
  multiplierName: string | undefined;
  multipleSportName: string;
  numberOfSelections: number;
  collapsibleOpen: boolean;
}> = ({
  multiplierName,
  multipleSportName,
  numberOfSelections,
  collapsibleOpen,
}) => (
  <div className="report__header">
    <div className={"report__header__icon"}>
      <IconSports name={multipleSportName} />
    </div>
    <div className="report__header__title">
      <div className="report__header__title report__header__title--open-bets">
        <div className="report__header__title__primary">
          <span>{multiplierName}</span>
        </div>
        <div className="report__header__title__secondary">
          <div className="report__header__collapsible">
            <span className="report__header__collapsible__text">
              {numberOfSelections > 0 && (
                <FormattedMessage
                  tagName="span"
                  id="bet-builder-selections"
                  values={{
                    numberOfSelections,
                  }}
                  defaultMessage={""}
                />
              )}
            </span>
            <span
              className={`report__header__collapsible__arrow ${
                collapsibleOpen ? "report__header__collapsible__arrow--up" : ""
              }`}
            >
              <IconChevronDown currentColor />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
);
